module.exports = __webpack_public_path__ + "static/img/07.06f1ce8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/07.jpg
// module id = 5kQj
// module chunks = 0